export const ajaxTimeout = 30000;
export const ajaxLongTimeout = 120000;
export const pagesWithoutLogin = ['/', '/err', '/imprint', '/privacy'];
export const maxResults = 2000; // make it lower to prevent possible limit in Kubernetes
export const allowedDomainsForSerialMail = ['joerg-lienert.ch', 'personal-total.de', 'senator-partners.de', 'match-flix.de'];
